module.exports = __webpack_public_path__ + "static/img/m100-right.4310156.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m100-right.png
// module id = 8ekp
// module chunks = 0